module.exports = __webpack_public_path__ + "img/check-mark.e8bd3f2c.svg";